export type ContentAlignmentType = 'left' | 'center' | 'right';

export type ContentWidthSpanType = 'full' | '1/2' | '1/3' | '2/3' | '1/4' | '3/4';

export const ContentWidthPercentages: Record<ContentWidthSpanType, string> = {
  full: '100%',
  '1/2': '50%',
  '1/3': '33.33%',
  '2/3': '66.66%',
  '1/4': '25%',
  '3/4': '75%',
};

export type ContentWidthPercentageValues = (typeof ContentWidthPercentages)[keyof typeof ContentWidthPercentages];

export type FlexDirectionType = 'row' | 'row-reverse' | 'column' | 'column-reverse';

export type FlexWrapType = 'nowrap' | 'wrap' | 'wrap-reverse' | 'inherit' | 'initial' | 'unset' | 'revert';

export type JustifyContentType =
  | 'space-between'
  | 'center'
  | 'end'
  | 'flex-end'
  | 'flex-start'
  | 'left'
  | 'normal'
  | 'right'
  | 'safe'
  | 'space-around'
  | 'space-evenly'
  | 'start'
  | 'stretch'
  | 'unsafe'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'unset';

export type AlignItemsType =
  | 'baseline'
  | 'center'
  | 'end'
  | 'first'
  | 'flex-end'
  | 'flex-start'
  | 'last'
  | 'normal'
  | 'safe'
  | 'self-end'
  | 'self-start'
  | 'start'
  | 'stretch'
  | 'unsafe'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'unset';

export type TextTransformType = 'uppercase' | 'lowercase' | 'capitalize';

export type DisplayType =
  | 'block'
  | 'inline'
  | 'inline-block'
  | 'flex'
  | 'inline-flex'
  | 'grid'
  | 'inline-grid'
  | 'flow-root'
  | 'none'
  | 'inherit';

export type FontWeightType = 100 | 200 | 300 | 400 | 500 | 600;

export type BorderStyleType =
  | 'dotted'
  | 'dashed'
  | 'solid'
  | 'double'
  | 'groove'
  | 'ridge'
  | 'inset'
  | 'outset'
  | 'none'
  | 'hidden';

export type WhiteSpaceType = 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' | 'break-spaces';

export type PositionType = 'static' | 'relative' | 'fixed' | 'absolute' | 'sticky';

export type OverflowType = 'inherit' | 'auto' | 'hidden' | 'scroll' | 'visible';
